module.exports = __webpack_public_path__ + "images/STOP_LIGHT_OFF.e6fb41f72fb9542a8774eab3564bd30c.png";